import React from "react";

import ShopForgotPassword from "../../components/Shop/ShopForgotPassword";

const ShopForgotPasswordPage = () => {
  return (
    <div>
      <div className="min-h-screen">
        <br />
        <br />
        <ShopForgotPassword />
      </div>
    </div>
  );
};

export default ShopForgotPasswordPage;
